import { useState } from 'react';
import Footer from '../component/Footer';
import Navbar from '../component/Navbar';
import '../hamcss/csr.css';
import '../hamcss/ombudsman.css';

import { FaRegFilePdf } from 'react-icons/fa';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import DotRing from '../component/dot/DotRing';
import banner from '../assests/CSR/banner.webp'; // TODO: replace with an Ombudsman banner if you have one
import ombudsmanPdf from '../assests/sgPdf/ombudsman/RBI Integrated Ombudsman Scheme 2026.pdf';
import salientEnglish from '../assests/sgPdf/ombudsman/salient/English.pdf';
import Assamese from '../assests/sgPdf/ombudsman/salient/Assamese.pdf';
import Bengali from '../assests/sgPdf/ombudsman/salient/Bengali.pdf';
import Gujarati from '../assests/sgPdf/ombudsman/salient/Gujarati.pdf';
import Hindi from '../assests/sgPdf/ombudsman/salient/Hindi.pdf';
import Kannada from '../assests/sgPdf/ombudsman/salient/Kannada.pdf';
import Malayalam from '../assests/sgPdf/ombudsman/salient/Malayalam.pdf';
import Marathi from '../assests/sgPdf/ombudsman/salient/Marathi.pdf';
import Odiya from '../assests/sgPdf/ombudsman/salient/Odiya.pdf';
import Punjabi from '../assests/sgPdf/ombudsman/salient/Punjabi.pdf';
import Tamil from '../assests/sgPdf/ombudsman/salient/Tamil.pdf';
import Telugu from '../assests/sgPdf/ombudsman/salient/Telugu.pdf';

// One PDF per language. Only English is available for now.
// When another language PDF is ready, import it above and set it as that language's `pdf`.
const languages = [
    { code: 'as', label: 'Assamese', pdf: Assamese },
    { code: 'bn', label: 'Bengali', pdf: Bengali },
    { code: 'en', label: 'English', pdf: salientEnglish },
    { code: 'gu', label: 'Gujarati', pdf: Gujarati },
    { code: 'hi', label: 'Hindi', pdf: Hindi },
    { code: 'kn', label: 'Kannada', pdf: Kannada },
    { code: 'ml', label: 'Malayalam', pdf: Malayalam },
    { code: 'mr', label: 'Marathi', pdf: Marathi },
    { code: 'or', label: 'Odiya', pdf: Odiya },
    { code: 'pa', label: 'Punjabi', pdf: Punjabi },
    { code: 'ta', label: 'Tamil', pdf: Tamil },
    { code: 'te', label: 'Telugu', pdf: Telugu },
];

const TABS = [
    { id: 'scheme', label: 'RBI Integrated Ombudsman Scheme 2026' },
    { id: 'features', label: 'Salient Features' },
    { id: 'pno', label: 'Principal Nodal Officer Details' },
];

const PNO_ROWS = [
    { label: 'Name', value: 'Mr. Anshul Manchanda' },
    {
        label: 'E-mail',
        value: <a href="mailto:principal.nodal@sgfinserve.com">principal.nodal@sgfinserve.com</a>,
    },
    { label: 'Contact', value: <a href="tel:+918586944917">+91-8586944917</a> },
    {
        label: 'Address',
        value: '35-36, Kaushambi Near Anand Vihar Terminal Ghaziabad Uttar Pradesh 201010 (India).',
    },
];

const OmbudsmanScheme = () => {
    const [activeTab, setActiveTab] = useState('scheme');

    return (
        <>
            <DotRing />
            <Navbar />

            {/* Page header / banner */}
            <section>
                <div
                    className="BreadArea"
                    style={{
                        backgroundImage: `url('${banner}')`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        height: '43vh',
                    }}
                >
                    <div style={{ marginTop: '30px' }} className="container">
                        <h2 style={{ wordSpacing: '1px', letterSpacing: '0.2px' }}>Ombudsman Scheme</h2>
                    </div>
                </div>
            </section>

            <section style={{ display: 'flex', justifyContent: 'center' }}>
                <section className="containner">
                    {/* Breadcrumb */}
                    <nav className="omb-breadcrumb" aria-label="Breadcrumb">
                        <a href="/">Home</a>
                        <span>›</span>
                        <span className="omb-breadcrumb-current">Ombudsman Scheme</span>
                    </nav>

                    {/* Main tabs */}
                    <div className="omb-tabs" role="tablist">
                        {TABS.map((tab) => (
                            <button
                                key={tab.id}
                                role="tab"
                                aria-selected={activeTab === tab.id}
                                className={`omb-tab ${activeTab === tab.id ? 'omb-tab-active' : ''}`}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* TAB 1: PDF */}
                    {activeTab === 'scheme' && (
                        <section className="omb-panel" role="tabpanel">
                            <p className="omb-lead">Click below to view the RBI Integrated Ombudsman Scheme 2026:</p>

                            <div className="omb-pdf-row">
                                <div className="omb-pdf-title">
                                    <FaRegFilePdf size={22} style={{ color: 'red' }} />
                                    <a href={ombudsmanPdf} target="_blank" rel="noopener noreferrer">
                                        RBI integrated Ombudsman Scheme 2026
                                    </a>
                                </div>
                            </div>
                        </section>
                    )}

                    {/* TAB 2: Salient features - one PDF per language, opens in a new tab */}
                    {activeTab === 'features' && (
                        <section className="omb-panel" role="tabpanel">
                            <p className="omb-lead">Select a language to view the Salient Features (opens in a new tab):</p>

                            <div className="omb-langs" aria-label="Select language">
                                {languages.map((l) =>
                                    l.pdf ? (
                                        <a
                                            key={l.code}
                                            href={l.pdf}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="omb-lang omb-lang-active"
                                        >
                                            <FaRegFilePdf /> {l.label}
                                        </a>
                                    ) : (
                                        <span
                                            key={l.code}
                                            className="omb-lang omb-lang-disabled"
                                            aria-disabled="true"
                                            title="Not available yet"
                                        >
                                            {l.label}
                                        </span>
                                    )
                                )}
                            </div>
                        </section>
                    )}

                    {/* TAB 3: Principal Nodal Officer table */}
                    {activeTab === 'pno' && (
                        <section className="omb-panel" role="tabpanel">
                            <h3>Principal Nodal Officer</h3>
                            <p className="p-text-csr-1">
                                The details of the Principal Nodal Officer of the Company as per Reserve Bank of India’s
                                Integrated Ombudsman Scheme dated July 01, 2026 are given below:
                            </p>

                            <div className="omb-table-wrap">
                                <table className="omb-table">
                                    <thead>
                                        <tr>
                                            <th>S. No.</th>
                                            <th>Particulars</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {PNO_ROWS.map((r) => (
                                            <tr key={r.label}>
                                                <td>{r.label}</td>
                                                <td>{r.value}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    )}

                    <div>
                        <FloatingWhatsApp phoneNumber="919205556122" accountName="Customer Care" />
                    </div>

                    <Footer />
                </section>
            </section>
        </>
    );
};

export default OmbudsmanScheme;